import clsx from "clsx";
import { NavLink } from "react-router-dom";

import {
  SIDEBAR_HOVER_BG,
  SIDEBAR_ITEM_ACTIVE,
  SIDEBAR_ITEM_BASE,
  SIDEBAR_ITEM_COLLAPSED,
  SIDEBAR_ITEM_EXPANDED,
  SIDEBAR_TEXT_INACTIVE,
} from "./sidebarClassNames";
import { getModuleSidebarIconTone } from "./useSidebarState";
import type { SidebarDashboardItem } from "./useSidebarState";

type Props = {
  item: SidebarDashboardItem;
  collapsed: boolean;
  isActive: boolean;
};

export function SidebarDashboardNavLink({ item, collapsed, isActive }: Props) {
  const Icon = item.icon;
  return (
    <NavLink
      to={item.href}
      className={clsx(
        SIDEBAR_ITEM_BASE,
        collapsed ? SIDEBAR_ITEM_COLLAPSED : SIDEBAR_ITEM_EXPANDED,
        isActive ? SIDEBAR_ITEM_ACTIVE : [SIDEBAR_TEXT_INACTIVE, SIDEBAR_HOVER_BG],
      )}
      aria-current={isActive ? "page" : undefined}
      aria-label={collapsed ? item.name : undefined}
      title={collapsed ? item.name : undefined}
    >
      <span
        aria-hidden="true"
        className={clsx(
          "absolute left-0 top-1.5 bottom-1.5 w-1 rounded-r",
          isActive ? "bg-blue-600 dark:bg-blue-400" : "bg-transparent",
        )}
      />
      <span className={clsx("flex items-center", collapsed ? "pl-0" : "pl-2")}>
        <Icon
          className={clsx("w-5 h-5", getModuleSidebarIconTone("home", isActive))}
          aria-hidden={true}
        />
      </span>
      {!collapsed && (
        <span className="flex-1 text-sm font-medium truncate">{item.name}</span>
      )}
    </NavLink>
  );
}
